<template>
  <div class="card-box" id="emails-component">
    <h4 class="header-title m-t-0 m-b-10">Emails</h4>
    <el-table :data="emails" stripe>
      <el-table-column type="expand">
        <template slot-scope="props">
          <iframe :srcdoc="props.row.message" style="width: 100%; min-height: 300px; border: 0;"></iframe>
        </template>
      </el-table-column>
      <el-table-column label="Plat." width="80">
        <template slot-scope="scope">
          <source-app name="devis-b2b" size="tiny"></source-app>
        </template>
      </el-table-column>
      <el-table-column prop="status" :filters="filterStatus" :filter-method="filterStatusMethod" label="Status">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 'PENDING'" class="label label-secondary">En attente (pending)</span>
          <span v-if="scope.row.status === 'SENT'" class="label label-primary">Envoyé</span>
          <span v-if="scope.row.status === 'DELAYED'" class="label label-secondary">En attente (delayed)</span>
          <span v-if="scope.row.status === 'OPENED'" class="label label-success">Ouvert</span>
          <span v-if="scope.row.status === 'CLICKED'" class="label label-success">Cliqué</span>
          <span v-if="scope.row.status === 'BOUNCED'" class="label label-danger">Non délivré (bounced)</span>
          <span v-if="scope.row.status === 'BLOCKED'" class="label label-danger">Non délivré (blocked)</span>
          <span v-if="scope.row.status === 'SPAM'" class="label label-dangers">Spam</span>
          <span v-if="scope.row.status === 'DROPPED'" class="label label-danger">Non délivré (dropped)</span>
          <span v-if="scope.row.status === 'DELIVERED'" class="label label-primary">Délivré</span>

          <small>({{ scope.row.updated_at | moment('DD/MM/YYYY HH:mm') }})</small>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Envoyé le">
        <template slot-scope="scope">
          {{ scope.row.created_at.date | moment('DD/MM/YYYY') }}
        </template>
      </el-table-column>
      <el-table-column prop="to" :filters="filterTo" :filter-method="filterToMethod"
                       label="Destinataire"></el-table-column>
      <el-table-column prop="subject" :filters="filterSubject" :filter-method="filterSubjectMethod"
                       label="Sujet"></el-table-column>
      <el-table-column label="Pièces jointes">
        <template slot-scope="scope">
          <ul v-if="scope.row.attachments.length !== 0">
            <li v-for="(path, name) in scope.row.attachments"><span class="label label-primary"><i
              class="fa fa-file"></i></span> {{ name }}
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="forwardId = scope.row.source_id">Transférer</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="Transférer un email" :visible.sync="forwardModalVisible" size="tiny">
      <el-form>
        <el-form-item label="Adresse Email">
          <el-input v-model="forwardTo" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="forwardId = null">Fermer</el-button>
        <el-button @click="forward()" type="primary">Transférer</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import SourceApp from '@db2b/keystone/components/Entities/SourceApp.vue'
  import moment from 'moment'

  export default {
    components: {
      SourceApp
    },
    name: 'emails',
    props: ['customer', 'relations'],
    data () {
      return {
        forwardId: null,
        forwardTo: null
      }
    },
    computed: {
      forwardModalVisible: {
        get () {
          return this.forwardId !== null
        },
        set () { }
      },
      emails () {
        return this.relations.emails.sort((a, b) => {
          return new Date(b.created_at.date) - new Date(a.created_at.date)
        })
      },
      filterStatus () {
        return [
          {text: 'En attente (pending)', value: 'PENDING'},
          {text: 'En attente (delayed)', value: 'SENT'},
          {text: 'Ouvert', value: 'OPENED'},
          {text: 'Cliqué', value: 'CLICKED'},
          {text: 'Délivré', value: 'DELIVERED'},
          {text: 'Spam', value: 'SPAM'},
          {text: 'Non délivré (bounced)', value: 'BOUNCED'},
          {text: 'Non délivré (blocked)', value: 'BLOCKED'},
          {text: 'Non délivré (dropped)', value: 'DROPPED'}
        ]
      },
      filterTo () {
        return this.relations.emails.map(item => {
          return item.to
        }).filter(function (item, pos, self) {
          return self.indexOf(item) === pos
        }).map(to => {
          return {text: to, value: to}
        })
      },
      filterSubject () {
        return this.relations.emails.map(item => {
          return item.subject
        }).filter(function (item, pos, self) {
          return self.indexOf(item) === pos
        }).map(to => {
          return {text: to, value: to}
        })
      }
    },
    methods: {
      forward () {
        let self = this

        this.$nexus.post('platform', 'api/legacy/email/' + this.forwardId + '/forward', {email: this.forwardTo})
          .then(() => {
            self.$message.success('L\'email a bien été transféré.')
            self.forwardId = null
            self.forwardTo = null
          })
      },
      filterStatusMethod (value, row) {
        return row.status === value
      },
      filterToMethod (value, row) {
        return row.to === value
      },
      filterSubjectMethod (value, row) {
        return row.subject === value
      }
    }
  }
</script>

<style>
  #emails-component .el-table__expanded-cell {
    padding: 0
  }
</style>



// WEBPACK FOOTER //
// Emails.vue?c130fd84